import axios from 'axios';

export const dynamicForm = ($el, form) => {

  axios.get('/api/forms.json', {
    params: {
      'x-form': form
    }
  })
    .then(function (response) {
      // Update the Form Hash
      $el.querySelector('input[name=formHash]').value = response.data.hash;

      // Update the Payload if encrypted payloads are enabled
      const payloadField = $el.querySelector('input[name=freeform_payload]')
      if (payloadField) {
        payloadField.value = response.data.payload;
      }

      // Locate and update the CSRF input
      var csrf = response.data.csrf;
      if ($el.querySelectorAll('input[name=' + csrf.name + ']').length) {
        $el.querySelector('input[name=' + csrf.name + ']').value = csrf.value;
      }
    })
    .catch(function (error) {
      console.error(error);
    });
}

export const injectCsrf = ($el, form) => {
  axios.get('/api/csrf.json', {})
    .then(function (response) {
      // Locate and update the CSRF input
      var csrf = response.data.csrf;
      if ($el.querySelectorAll('input[name=' + csrf.name + ']').length) {
        $el.querySelector('input[name=' + csrf.name + ']').value = csrf.value;
      }
    })
    .catch(function (error) {
      console.log(error);
    });
}
